import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core';
import { MonitorRoutingModule } from './monitor-routing.module';
import { RedisComponent } from './redis/redis.component';
import { MonitorService } from './monitor.service';
import { ActivityComponent } from './activity/activity.component';
import { MetricsComponent } from './metrics/metrics.component';

@NgModule({
  imports: [CommonModule, CoreModule, MonitorRoutingModule],
  declarations: [RedisComponent, ActivityComponent, MetricsComponent],
  providers: [MonitorService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MonitorModule {}
